
      import Chart from "chart.js/auto";
      import annotationPlugin from "chartjs-plugin-annotation";

      Chart.register(annotationPlugin);
    